import { FC } from 'react';

import MoonSvgAsset from './moon.svg?react';

export const MoonSvg: FC<{ size: number }> = ({ size }) => <MoonSvgAsset width={size} height={size} />;
